import React from "react";

export default function ChartCard({ title, subtitle, action, children, className = "" }) {
  return (
    <div className={`card-surface p-5 ${className}`}>
      <div className="mb-4 flex items-start justify-between">
        <div>
          <h3 className="font-heading text-base font-semibold text-slate-800">{title}</h3>
          {subtitle && <p className="text-xs text-slate-400">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}

export const CHART_COLORS = ["#291d89", "#4e67eb", "#38bdf8", "#818cf8", "#c084fc"];

export function chartTooltipStyle() {
  return {
    contentStyle: {
      borderRadius: "12px",
      border: "1px solid #f1f5f9",
      boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
      fontSize: "12px",
    },
  };
}
